export const Buttons = (() => {
    'use strict';

    let buttons;

    function init() {
        buttons = document.querySelectorAll('.btn');

		if(buttons.length < 1) {
			return;
		}

		document.addEventListener('mousemove', function(e) {
			buttons.forEach(function(btn) {
				var rect = btn.getBoundingClientRect();

				if(
					e.clientX + 60 > rect.left &&
					e.clientX - 60 < rect.left + rect.width &&
					e.clientY + 60 > rect.top &&
					e.clientY - 60 < rect.top + rect.height
				) {
					let x = Math.round(e.clientX - rect.left);
			        let y =  Math.round(e.clientY - rect.top);

					btn.style.setProperty('--left', x + 'px');
					btn.style.setProperty('--top', y + 'px');
					btn.style.setProperty('--opacity', 1);
				} else {
					btn.style.setProperty('--opacity', 0);
				}
			});
		});
    }

    return {
        init: init
    };
})();